import { useRef } from 'react';
import { useInViewport } from 'ahooks';

export type TRef = HTMLDivElement & HTMLSpanElement;

// `root` is omitted: ahooks' `useInViewport` only reads it once when constructing the observer
// (unlike react-use's `useIntersection`, which rebuilt on every `root` change), so exposing it here
// would silently ignore later changes. No current consumer passes it.
export type UseIsVisibleOptions = Omit<IntersectionObserverInit, 'root'>;

export function useIsVisible<T extends HTMLElement = TRef>(options: UseIsVisibleOptions = {}) {
  const ref = useRef<T>(null);
  const [isVisible] = useInViewport(ref, options);

  return { ref, isVisible: isVisible ?? false } as const;
}
